import PageShell from '@/components/feature/PageShell';
import PageIntro from '@/components/feature/PageIntro';
import FinalCta from '@/components/feature/FinalCta';
import Container from '@/components/base/Container';
import Eyebrow from '@/components/base/Eyebrow';
import PreviewNotice from '@/components/base/PreviewNotice';
import TechnicianCard from '@/components/feature/TechnicianCard';
import type { Technician } from '@/types/customer';
import { technicians } from '@/mocks/technicians';

const approach = [
  { title: 'Diagnosis', text: 'Every visit starts by finding the real cause, not by guessing at parts.' },
  { title: 'Clear Estimate', text: 'What was found and what it costs is explained before any repair begins.' },
  { title: 'In-Home Repair', text: 'Work is carried out carefully, with protected floors and a tidy finish.' },
];

export default function TechniciansPage() {
  const list = technicians as Technician[];
  return (
    <PageShell>
      <PageIntro eyebrow="Our People" title="The People Behind Every Repair.">
        Careful workmanship and professional, respectful service, from the people responsible for keeping your household appliances working.
      </PageIntro>

      <section className="bg-background-50 pb-20 md:pb-28">
        <Container>
          <PreviewNotice>
            Technician records are not connected yet. The profiles below are <strong>sample profiles</strong> for visual demonstration and do not represent real MENDWELL staff.
          </PreviewNotice>
          <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-2 lg:grid-cols-3">
            {list.map((t) => <TechnicianCard key={t.slug} tech={t} />)}
          </div>
        </Container>
      </section>

      <section className="bg-background-100 py-20 md:py-28">
        <Container>
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-16">
            <Eyebrow label="Service Approach" />
            <h2 className="text-[30px] md:text-[44px] font-medium leading-[1.05] tracking-[-0.025em] text-foreground-950">Diagnose, explain, then repair.</h2>
          </div>
          <div className="mt-12">
            {approach.map((a, i) => (
              <div key={a.title} className="grid grid-cols-1 gap-3 border-t border-background-200 py-8 lg:grid-cols-2 lg:gap-16 last:border-b">
                <span className="text-xs text-foreground-600">{`0${i + 1}`}</span>
                <div>
                  <h3 className="text-lg font-medium text-foreground-950">{a.title}</h3>
                  <p className="mt-2 max-w-md text-[15px] leading-relaxed text-foreground-600">{a.text}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
      <FinalCta />
    </PageShell>
  );
}